import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ComponentsComponent } from './components/components/components.component';
import { NoauthorizedComponent } from './components/noauthorized/noauthorized.component';

const routes: Routes = [
  {
    path: 'components', component: ComponentsComponent
  },
  {
    path: 'noauthorized', component: NoauthorizedComponent
  }];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
